export const RESTRICTED_COMMUNICATION_STATUSES = ['Blacklisted', 'Deactivated'];

export const normalizeInstructorAccountStatus = (status) => (
  String(status || '').trim() || 'Active'
);

export const canInstructorManageCommunicationPreference = (status) => (
  !RESTRICTED_COMMUNICATION_STATUSES.includes(normalizeInstructorAccountStatus(status))
);

export const isInstructorOptedIntoCommunication = (status) => {
  const normalized = normalizeInstructorAccountStatus(status);
  return normalized !== 'Paused' && !RESTRICTED_COMMUNICATION_STATUSES.includes(normalized);
};

export const getNextCommunicationAccountStatus = (shouldReceiveOutreach) => (
  shouldReceiveOutreach ? 'Active' : 'Paused'
);

export const getInstructorCommunicationBadge = (status) => {
  const normalized = normalizeInstructorAccountStatus(status);

  if (normalized === 'Paused') {
    return {
      label: 'Outreach paused',
      colorScheme: 'orange',
    };
  }

  if (RESTRICTED_COMMUNICATION_STATUSES.includes(normalized)) {
    return {
      label: 'Support needed',
      colorScheme: 'gray',
    };
  }

  return {
    label: 'Available for outreach',
    colorScheme: 'green',
  };
};

export const buildInstructorCommunicationPreferenceActivity = ({
  userDocId,
  email,
  nextStatus,
  nowMs = Date.now(),
} = {}) => ({
  type: nextStatus === 'Paused' ? 'communications_paused' : 'communications_resumed',
  title: nextStatus === 'Paused' ? 'Class Opportunity Outreach Paused' : 'Class Opportunity Outreach Resumed',
  body: nextStatus === 'Paused'
    ? 'Instructor paused class opportunity outreach via email and text.'
    : 'Instructor resumed class opportunity outreach via email and text.',
  timestamp: nowMs,
  actor: {
    userDocId,
    email: String(email || '').trim().toLowerCase(),
  },
  metadata: {
    nextStatus,
    source: 'instructor_profile',
  },
});
